import { render, staticRenderFns } from "./Definition.vue?vue&type=template&id=ddc1ace2&"
import script from "./Definition.vue?vue&type=script&lang=js&"
export * from "./Definition.vue?vue&type=script&lang=js&"
import style0 from "./Definition.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports